import { StreamType, } from '@zattoo/playback-sdk';
import * as StreamQuality from '@zattoo/zapi/lib/stream/enums/stream-qualities';
// There probably is no special processing of the hdcp level for rakuten streams in betty or streamapi,
// as the HDCP level is already implicit in the maxQuality. This function therefore might be redundant.
export const maxHdcpType = (deviceCapabilities) => {
    const version = deviceCapabilities.hdcpLevel?.connectedVersion;
    if (!version) {
        return 'Unprotected';
    }
    // Rakuten supported HDCP levels
    // https://zattoo2.atlassian.net/browse/PLY-633
    if (Number(version) >= 2.2) {
        return 1;
    }
    if (Number(version) >= 1.4) {
        return 0;
    }
    return 'Unprotected';
};
export const maxQuality = (deviceCapabilities) => {
    const dashPlayready = deviceCapabilities.streamTypeInformation.find((type) => type.type === StreamType.DASH_PLAYREADY);
    const dashWidevine = deviceCapabilities.streamTypeInformation.find((type) => type.type === StreamType.DASH_WIDEVINE);
    const streamTypeInformation = dashPlayready ?? dashWidevine;
    const hdcp = deviceCapabilities.hdcpLevel?.connectedVersion ?? null;
    const drm = streamTypeInformation?.maxSecurityLevel ?? null;
    if (hdcp === null || drm === null) {
        return StreamQuality.SD;
    }
    const drmLevel = typeof drm === 'string'
        ? Number(drm.replace(/[a-zA-Z]/g, ''))
        : drm;
    const hdcpVersion = typeof hdcp === 'string'
        ? Number(hdcp)
        : hdcp;
    if (streamTypeInformation?.type === StreamType.DASH_PLAYREADY) {
        if (drmLevel === 3000) {
            if (hdcpVersion >= 2.2) {
                return StreamQuality.UHD;
            }
            else if (hdcpVersion >= 2.1) {
                return StreamQuality.FHD;
            }
            else {
                return StreamQuality.SD;
            }
        }
        else if (drmLevel === 2000) {
            if (hdcpVersion >= 2.1) {
                return StreamQuality.FHD;
            }
            else {
                return StreamQuality.SD;
            }
        }
    }
    else if (streamTypeInformation?.type === StreamType.DASH_WIDEVINE) {
        if (drmLevel <= 3) {
            if (hdcpVersion >= 2.1) {
                return StreamQuality.FHD;
            }
        }
        else {
            return StreamQuality.SD;
        }
    }
    return StreamQuality.SD;
};
